export enum SyncStatus {
  inSync = 'in-sync',
  outOfSync = 'out-of-sync'
}
